import { Uploader } from "./upload_common";
import { S3Upload } from "./s3";

class MultiRowUploader extends Uploader {
    constructor(root) {
        super(root)
        this.fileCount = 0
        this.resetRows()
    }

    resetRows() {
        this.rows = []
        for (let i = 0; i < 13; i++) {
            this.rows.push([])
        }
    }

    validateRow(target, files) {
        const container = target.closest('.uploader-container')
        const status = container.querySelector('.upload-status')
        const row = parseInt(container.getAttribute('data-row'))

        this.rows[row] = []

        if (files.length < 4 || files.length > 72) {
            this.statusError(status, 'Please upload 4..72 images (.jpg, .jpeg, .png)')
            return
        }

        for (let file of files) {
            if (!this.isImage(file)) {
                this.statusError(status, 'Please upload 4..72 images (.jpg, .jpeg, .png)')
                return
            }
        }

        this.statusSuccess(status, `${files.length} files selected`)

        this.rows[row] = files

        this.fileCount = this.rows.reduce((acc, cur) => acc + cur.length, 0)

        if (this.fileCount > 0) {
            this.submitButton.removeAttribute('disabled')
        }
    }

    doSubmit() {
        if (this.fileCount > 0) {
            const result = this.postVariant()
            if (!result?.uuid) {
                this.submitted = false
                const message = (result?.errors && Object.values(result.errors).flat()[0]) || 'Upload failed. Please try again.'
                this.uploadFailed(message)
                return
            }
            const variant = result
            const uploader = new S3Upload(variant, this)

            for (let row = 1; row < 13; row++) {
                uploader.enqueue("frames", row, this.rows[row])
            }

            uploader.upload()
        }
    }
}

function initializeMultiRowUploaders() {
    const root = document.querySelector('#multirow_upload')
    if (root !== null && !root.dataset.uploaderInitialized) {
        new MultiRowUploader(root)
        root.dataset.uploaderInitialized = 'true'
    }
}

// Initialize on full page load (non-Turbo) and Turbo navigations
window.addEventListener('load', initializeMultiRowUploaders)
document.addEventListener('turbo:load', initializeMultiRowUploaders)
document.addEventListener('turbo:frame-load', initializeMultiRowUploaders)
